import { CoachmarkContextValue } from './types';
import { createContext, useContext } from 'react';

export const CoachmarkContext = createContext<CoachmarkContextValue | null>(null);

export const useCoachmarkContext = () => {
  const context = useContext(CoachmarkContext);

  if (!context) {
    throw new Error('Coachmark components must be used inside CoachmarkProvider');
  }

  return context;
};